// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'__sohne_507526', '__sohne_Fallback_507526'"},"className":"__className_507526","variable":"__variable_507526"};